var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M19.895 18.55l-9-18.041c-.34-.679-1.45-.679-1.79 0l-9 18.04c-.154.311-.139.68.044.977.182.295.503.474.85.474H19c.347 0 .668-.18.851-.475.182-.297.198-.664.044-.975zM9 7.973h2v6.013H9V7.973zm-.25 8.018c0 .692.56 1.253 1.25 1.253s1.25-.56 1.25-1.253c0-.692-.56-1.253-1.25-1.253s-1.25.561-1.25 1.253z",
    clipRule: "evenodd"
  })));
}
export default SvgError;